function Generator(app) {

	this.canvas;
	this.canvasCtx;

	this.printCanvas;
	this.printCanvasCtx;

	this.p = app;

	this.sourceWidth = app.camera.canvasResolution.width;
	this.sourceHeight = app.camera.canvasResolution.height;

	this.canvas = document.createElement('canvas');
	this.canvas.setAttribute("id", "display-canvas")
	this.canvasCtx = this.canvas.getContext("2d");
	this.canvas.width = 918;
	this.canvas.height = 1024

	this.printCanvas = document.createElement('canvas');
	this.printCanvas.setAttribute("id", "print-canvas")
	this.printCanvasCtx = this.printCanvas.getContext("2d");

	this.printScale = 2;
	this.printSize = 180;
	this.printCanvas.width = 850 * this.printScale;
	this.printCanvas.height = 550 * this.printScale;

	$("#screen-2").append(this.canvas)

	// $("#screen-2").append(this.printCanvas)
}

Generator.prototype.create = function (img, editor) {

	// Define source coordinates
	var sWidth = this.canvas.width * (1 / editor.scale);
	var sHeight = this.canvas.height * (1 / editor.scale);
	var sx = (this.sourceWidth - sWidth) / 2 + (-editor.offsetX * (1 / editor.scale));
	var sy = (this.sourceHeight - sHeight) / 2 + (-editor.offsetY * (1 / editor.scale));
	// console.log(sx, sy, sWidth, sHeight);

	// Draw image on output canvas
	this.canvasCtx.fillStyle = "black";
	this.canvasCtx.fillRect(0, 0, this.canvas.width, this.canvas.height);
	this.canvasCtx.drawImage(img, sx, sy, sWidth, sHeight, 0, 0, this.canvas.width, this.canvas.height);

	this.createPrint(img);
}

Generator.prototype.createPrint = function (img) {

	// Define destination coordinates
	var ratio = this.canvas.height / this.canvas.width;
	var dx = 105 * this.printScale;
	var dy = 85 * this.printScale;;
	var dw = this.printSize * this.printScale;;
	var dh = this.printSize * ratio * this.printScale;;

	// Draw image on output canvas
	this.printCanvasCtx.fillStyle = "white";
	this.printCanvasCtx.fillRect(0, 0, this.printCanvas.width, this.printCanvas.height);

	for (var i = 0; i < 2; i++) {
		this.printCanvasCtx.drawImage(this.canvas, 0, 0, this.canvas.width, this.canvas.height, dx + (this.printCanvas.width / 2 * i), dy, dw, dh);
	}
}

Generator.prototype.save = function (img, filename, callback) {
	var base64Img = this.printCanvas.toDataURL("image/png");
	var base64Data = base64Img.replace(/^data:image\/png;base64,/, "");

	if (fs) {
		var filePath = path.join(nw.App.dataPath, filename);
		console.log("Saving file to ", filePath);
		fs.writeFile(filePath, base64Data, 'base64', function (err) {
			if (err) {
				console.info("There was an error attempting to save your data.");
				console.warn(err.message);
				return;
			} else if (callback) {
				callback(filePath);
			}
		});
	}
}


// Expose App
window.Generator = Generator;